@if (!src) {
  <div style="width: 100%;" [style.height.px]="height">
    <canvas #canvas style="width: 100%; height:100%"></canvas>
  </div>
} @else if(src) {
  <div style="width: 100%;">
    <img [src]="src"/>
  </div>
}